module.exports = __webpack_public_path__ + "img/logovp3_LW40.dc48efd5.svg";